import { Divider, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { getContrastColor } from '../../../../core/common/visual.utils'
import { DoorWorkingModes } from '../../../../core/enum/DoorWorkingModes'
import { SetWorkingModeDialog } from '../../doors/DoorDialogs'
import { DoorWorkingModeById } from '../../../../core/devices/doors/doors.utils'

const useStyle = makeStyles({
  divider: {
    height: 1,
    width: '100%',
  },
})

export const DoorWorkingModeManagementButton = ({ ...props }) => {
  const { color, door, jsonStatus, fontSizeClass } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const [stateDialogOpen, setStateDialogOpen] = useState(false)
  const [workingMode, setWorkingMode] = useState<DoorWorkingModes | undefined>(
    undefined,
  )
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()
  const classes = useStyle()

  const handleSetWorkingMode = async (
    recurringJobName?: string,
    cronExpression?: string,
  ) => {
    await mutate(
      {
        type: sanitizeFetchType('setDoorWorkingMode'),
        resource: ResourceName.DOORS,
        payload: {
          doorId: door?.id,
          workingMode,
          recurringJobName,
          cronExpression,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
    setStateDialogOpen(false)
    refresh()
  }

  const handleCloseDialog = () => {
    setStateDialogOpen(false)
    setWorkingMode(undefined)
  }

  const handleOpenDialog = () => {
    setWorkingMode(
      DoorWorkingModeById[
        (jsonStatus?.WorkingMode as number) ||
          (jsonStatus?.workingMode as number)
      ],
    )
    setStateDialogOpen(true)
  }

  return (
    <>
      <SetWorkingModeDialog
        open={stateDialogOpen}
        close={handleCloseDialog}
        workingMode={workingMode}
        setWorkingMode={setWorkingMode}
        handleSetWorkingMode={handleSetWorkingMode}
        door={door}
      />
      <Button
        variant="text"
        className={fontSizeClass}
        style={{ color: getContrastColor(color) }}
        label="resources.doors.actions.setWorkingMode"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DOORS_SET_WORKING_MODE) ||
          loading ||
          mutationLoading
        }
        onClick={handleOpenDialog}
        fullWidth
      />
      <Divider className={classes.divider} />
    </>
  )
}
